import * as React from "react"

const SvgTagMinus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.15 22.286q-.375 0-.75-.15t-.675-.45l-7.15-7.15q-.3-.3-.438-.663a2.06 2.06 0 0 1 0-1.487q.138-.375.438-.675l7.8-7.825q.275-.276.65-.438a1.9 1.9 0 0 1 .775-.162h7.175q.825 0 1.412.587.588.588.588 1.413v7.175q0 .294-.081.567a6 6 0 0 0-1.919-.663v-7.08h-7.15L4 13.136l7.15 7.15.942-.945a6 6 0 0 0 .775 2.054l-.292.292q-.3.3-.675.45t-.75.15Z" />
    <path d="M15.475 10.286q.624 0 1.063-.438.437-.437.437-1.062t-.438-1.063a1.45 1.45 0 0 0-1.062-.437q-.624 0-1.063.437a1.45 1.45 0 0 0-.437 1.063q0 .624.438 1.062.436.438 1.062.438m-1.188 8.712q.288.288.713.288h6q.424 0 .712-.288a.97.97 0 0 0 .288-.712.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287h-6a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712" />
  </svg>
)
export default SvgTagMinus
